import Axios from 'axios';
import { getHeaders, getHeadersMultipart } from './headers';
import appConfig from '../../config/appConfig';

const configApi = {
  baseURL: `${appConfig.api.ENDPOINT}`,
};

const configApiMultipart = {
  baseURL: `${appConfig.api.ENDPOINT}`,
};

class Api {
  axios = Axios.create(configApi);

  axiosMultipart = Axios.create(configApiMultipart);

  async post(url, data, header) {
    const headers = header || getHeaders();
    return this.axios.post(url, data, { headers });
  }

  async put(url, data, header) {
    const headers = header || getHeaders();
    return this.axios.put(url, data, { headers });
  }

  async patch(url, data, header) {
    const headers = header || getHeaders();
    return this.axios.patch(url, data, { headers });
  }

  async get(url, params, header) {
    const headers = header || getHeaders();
    return this.axios.get(url, { params, headers });
  }

  async delete(url, params, header) {
    const headers = header || getHeaders();
    return this.axios.delete(url, { params, headers });
  }

  async postMultipart(url, data, headersMultipart) {
    const headers = headersMultipart || getHeadersMultipart();
    return this.axiosMultipart.post(url, data, { headers });
  }
}

export default new Api();
